import { render, staticRenderFns } from "./QPieChartCarrierPlaced.vue?vue&type=template&id=a09ff042&scoped=true&"
import script from "./QPieChartCarrierPlaced.vue?vue&type=script&lang=js&"
export * from "./QPieChartCarrierPlaced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09ff042",
  null
  
)

export default component.exports